import { Component, OnInit, AfterViewInit, OnDestroy, HostListener, ViewChild, NgZone } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Subscription, forkJoin } from 'rxjs';
import { ConfirmDialogComponent } from './../../../../common/components/confirm-dialog/confirm-dialog.component';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { LolLoggerService } from './../../../../common/shared/lol-logger.service';
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../../services/infrastructure/config.service';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { CommonService } from './../../../../services/common/common.service';
import * as $ from 'jquery';
import { FilterOption } from '../../../../common/components/filter/filter-model';
import { ControlType } from '../../../../common/components/filter/filter-enum';
import { AssociateCropService } from './../../../../services/seed/associate-crop.service';
import { MatTableDataSource } from '@angular/material/table';
import { FilterComponent } from '../../../../common/components/filter/filter.component';
import { ExcelService } from '../../../../services/infrastructure/excel.service';
import { SliderModelService } from './../../../../services/infrastructure/sliderModel.service';

@Component({
  selector: 'app-associate-crop-inventory',
  templateUrl: './associate-crop-inventory.component.html',
  styleUrl: './associate-crop-inventory.component.scss'
})

export class AssociateCropInventoryComponent implements OnInit, AfterViewInit, OnDestroy {
  // ===============================
  // ✅ Primitive Type Variables
  // ===============================
  @ViewChild(FilterComponent) private _filter: FilterComponent;
  showTabs = false;
  locationDataLoading: boolean = true;
  isDisableWholeFilter: boolean = true;
  sellerDataLoading: boolean = false;
  hasChangeAdded = false;
  isPlaceOrderDisable = true;
  isNotValid = false;
  isAddingNewItem = false;
  readOnlyAccess = false;
  selectedCount = 0;
  searchCount = 0;
  firstLoad: number = 0;
  currentRowId = 0;
  tabNode: '';
  newItemName = '';
  locationOpenMode: number = 0;
  emailAddress: string;
  duplicateCombinationError: string;
  dataCount = 0;
  selectedItemId: number | null = null;
  retailerId: string;
  res: string;
  // ===============================
  // ✅ Array Type Variables
  // ===============================
  subscription = new Array<Subscription>();
  productList: any[] = [];
  deleteList: any[] = [];
  marketingBrandList: any[] = [];
  selectedItems: any[] = [];
  InventoryDataSource = new MatTableDataSource([]);
  inventoryOriginalDataSourceGrid: any[] = [];
  displayedColumns: string[] = ['select', 'cropType', 'variety', 'marketingBrand', 'quantity', 'committedQty', 'availableQty', 'uom'];
  confirmationMsg: string = "";
  cropTypeMasterList: any[] = [];
  varietyMasterList: any[] = [];
  // ===============================
  // ✅ Object / Any Type Variables
  // ===============================
  locationData: any;
  sellerData: any;
  userMenuAccessList: any;
  formdata: any;
  growerLoading: any;
  growerList: any;
  shipToAccount: any;
  selectedProductLineId: any;
  selectedMarketingBrandId: any;
  growerSliderSubscription: any;
  filter:any;

  // ===============================
  // ✅ Constant / Class Instances
  // ===============================
  filterOptionsData: Array<FilterOption>;

  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    private toastrService: ToastrService,
    private matDialog: MatDialog,
    private commonService: CommonService,
    public broadcastService: BroadcastService,
    private configService: ConfigService,
    private associateCropService: AssociateCropService,
    public excelService: ExcelService,
    public sliderModelService: SliderModelService,
    private zone: NgZone
  ) {
    this.subscription.push(this.broadcastService.on<any>(this.configService.DATA_CHANGE_ADDED).subscribe((data) => {
      if (data.hasChangeAdded != undefined) {
        this.hasChangeAdded = data.hasChangeAdded;
      }
    }));
  }

  ngOnInit(): void {
    this.setDefaultformData(null);
    this.setFilterAndGridColumn();
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == MasterConstants.US_COMPANYCODE).userMenuAccessList;
        const associateInventoryAccess = data.resultData.find(x => x.userIdCompanyCode == MasterConstants.US_COMPANYCODE).associateInventoryAccess;
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.CROP_ASSOCIATES_INVENTORY) && associateInventoryAccess) {
          this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.CROP_ASSOCIATES_INVENTORY, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
          this.getAssociateInventoryInitialData();
        }
        else {
          this.router.navigate(['/cc/landing-data']);
        }
      }
    }
  }
  ngAfterViewInit() {
    this.setHeight();
    this.zone.onStable.subscribe(() => {
      this.setTableHeight();
    });
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setTableHeight();
    this.setHeight();
  }

  setHeight() {
    if (window.innerWidth < 767) {
      const templateHeight = window.innerHeight - 200;
      $('.productLabelFormPage').css('max-height', templateHeight + 'px');
    }
  }

  setTableHeight() {
    setTimeout(function () {
      let templateHeight = window.innerHeight - $('.order-view-sec').outerHeight() - $('.OrderReleaseTop').outerHeight() - $('.SeedFulfillBtnSec').outerHeight() - 150;

      const pageFooter = document.querySelectorAll<HTMLElement>('.chips-sec');
      if (pageFooter.length > 0) {
        templateHeight -= pageFooter[0].offsetHeight;
      }

      $('.tableOuterContainer').css('height', templateHeight + 'px');
    }, 100);
  }

  setDefaultformData(setDefaultLocation) {
    this.formdata = {
      locationId: setDefaultLocation ? setDefaultLocation : null
    };
  }
  setFilterAndGridColumn() {
    this.filterOptionsData = [
      { label: 'Crop Type', key: 'cropTypeCode', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id', isMultiSelect: false },
      { label: 'Marketing Brand', key: 'marketingBrand', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id', isMultiSelect: false },
      { label: 'Variety', key: 'brandList', controlType: ControlType.Text },
    ];

  }

  // Set Drop down values for filter
  setDropDownValues(source, type) {
    if (type === 'cropTypeCode') {
      const cropTypeList = this.getcropTypeList(source);
      this.filterOptionsData.find(x => x.key === 'cropTypeCode').controlData = cropTypeList && cropTypeList.length > 0 ? cropTypeList :[] ;
    }
    if (type === 'marketingBrand') {
      const brandList = this.getBrandList(source);
      this.filterOptionsData.find(x => x.key === 'marketingBrand').controlData = brandList && brandList.length > 0 ? brandList : [];
    }

  }

  getcropTypeList(source) {
    let result = [];
    const seen = new Set();
    for (const item of source) {
      if (item.cropTypeCode && !seen.has(item.cropTypeCode)) {
        seen.add(item.cropTypeCode);
        result.push({ id: item.cropTypeCode, value: item.cropTypeDesc });
      }
    }
    result = result?.sort((a, b) =>
      (a.value ?? '').localeCompare(b.value ?? '')
    );
    return result;
  }

  getBrandList(source) {
    let result = [];
    const seen = new Set();
    for (const item of source) {
      if (item.marketingBrand && !seen.has(item.marketingBrand)) {
        seen.add(item.marketingBrand);
        result.push({ id: item.marketingBrand, value: item.marketingBrand });
      }
    }
    result = result?.sort((a, b) =>
      (a.value ?? '').localeCompare(b.value ?? '')
    );
    return result;
  }
  // Search Action
  filterSearchClick(event) {
      if (this.hasChangeAdded) {
        const title = 'Leave without saving?';
        const message = '';
        const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
          disableClose: true,
          width: '480px',
          data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No, go back to Inventory Management', dialogType: 'confirm' }
        });
        this.subscription.push(dialogRef.afterClosed().subscribe(result => {
          if (result == true) {
            this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cancelBtnClick: true });
            this.sliderModelService.close();
            this.filter = event;
            this.applyFilterData();
          }
        }));
      }
      else {
        this.sliderModelService.close();
        this.filter = event;
        this.applyFilterData();
      }

  }


  // Clear All Action
  filterClearAllClick(event) {
    this.filter = event;
    this.InventoryDataSource.filter = this.filter;
    this.InventoryDataSource.data.forEach(x => x.selected = false);
    this.tabNode = '';
    this.selectedCount = 0;
  }


  getAssociateInventoryInitialData() {
    this.loaderService.setLoaderStatus(true);
    const forkJoinAPIs = [];
    forkJoinAPIs.push(this.associateCropService.getInventoryLocationList());
    forkJoinAPIs.push(this.associateCropService.getInventoryMasterData());
    this.subscription.push(forkJoin(forkJoinAPIs).subscribe((result: any[]) => {
      if (result && result.length > 0 && result[0] && result[1]) {
        this.locationDataLoading = false;
        this.locationData = result[0];
        this.cropTypeMasterList = result[1].associateCropTypeList;
        this.varietyMasterList = result[1].associateCropBrandList;
        if (this.locationData && this.locationData.length === 1) {
          this.locationOpenMode = 1;
          this.formdata.locationId = this.locationData[0].locationId;
          this.getDetailInventoryData(this.locationData[0].locationId);
        }
        if (this.locationData.length === 0) {
          this.locationOpenMode = 2;
          this.isDisableWholeFilter = true;
        }
        this.loaderService.setLoaderStatus(false);
      } else {
        this.locationDataLoading = false;
        this.locationData = [];
        this.InventoryDataSource = new MatTableDataSource([]);
        this.loaderService.setLoaderStatus(false);
      }
    }, error => {
      LolLoggerService.error(error);
      this.loaderService.setLoaderStatus(false);
      this.locationDataLoading = false;
    }));
  }

  getDetailInventoryData(locationId) {
    this.deleteList = [];
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, {
      updateButtonClick: true
    });
    this.isPlaceOrderDisable = true;
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.associateCropService
      .getInventoryLandingData(locationId)
      .subscribe(
        (result: any) => {
          const inventoryItemsList = result && result.length > 0
            ? result.map((item, index) => ({
              ...item,
              rowId: index + 1,
              lineErrors: {
                rowId: index + 1,
                errors: []
              },
              selected: false,
              isNewLine: false,
              hasError: false,
              previousQty: item.quantity
            }))
            : [];
          this.currentRowId = inventoryItemsList.length;
          this.setDropDownValues(inventoryItemsList, 'cropTypeCode');
          this.setDropDownValues(inventoryItemsList, 'marketingBrand');
          this.isDisableWholeFilter = inventoryItemsList.length <= 0;
          this.inventoryOriginalDataSourceGrid =
            inventoryItemsList.map(x => ({ ...x }));

          this.InventoryDataSource =
            new MatTableDataSource(
              inventoryItemsList.map(x => ({ ...x }))
            );

          this.InventoryDataSource.filterPredicate = this.inventoryFilterPredicate;
          if (this.filter) {
            this.InventoryDataSource.filter = this.filter;
          }
          this.loaderService.setLoaderStatus(false);
        },
        (error) => {
          LolLoggerService.error(error);
          this.loaderService.setLoaderStatus(false);
        }
      ));
  }

  applyFilterData() {
    this.getDetailInventoryData(this.formdata.locationId);
    this.tabNode = '';
    this.selectedCount = 0;
    this.deleteList = [];
  }

  enableAllCheckBoxes(isChecked) {
    if (isChecked) {
      this.showTabs = true;
      this.InventoryDataSource.data.forEach(x => {
        x.selected = true;
      });
      this.selectedCount = this.InventoryDataSource.data.length;
    }
    else {
      this.showTabs = false;
      this.InventoryDataSource.data.forEach(x => {
        x.selected = false;
        x.lineErrors.errors = x.lineErrors.errors.filter(y => y.id != 'deleteInventory');
      });
      this.InventoryDataSource.data = [...this.InventoryDataSource.data];
      this.selectedCount = 0;
      this.enableDisableUpdateButton();
    }
  }

  enableCheckBoxSingle(isChecked, element) {
    this.selectedCount = this.InventoryDataSource.data.filter(x => x.selected == true).length;
    if (isChecked) {
      this.showTabs = true;
    }
    else {
      const uncheckedItem = this.InventoryDataSource.data.find(x => x.rowId == element.rowId);
      if (uncheckedItem) {
        uncheckedItem.lineErrors.errors = uncheckedItem.lineErrors.errors.filter(y => y.id != 'deleteInventory');
      }
      this.InventoryDataSource.data = [...this.InventoryDataSource.data];
      if (this.selectedCount == 0) {
        this.showTabs = false;
      }
    }
    this.enableDisableUpdateButton();
  }

  onLocationDdlChange(event) {
    if (event && event.locationId) {
      this.formdata.locationId = event.locationId;
      this.getDetailInventoryData(this.formdata.locationId);
    }
    else {
      this.InventoryDataSource = new MatTableDataSource([]);
      this.inventoryOriginalDataSourceGrid = [];
      this.isDisableWholeFilter = true;
      this.deleteList = [];
      this.isPlaceOrderDisable = true;
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, {
        updateButtonClick: true
      });
    }
    this._filter.clearAllFilterWithoutEmit();
    this.setDefaultformData(event?.locationId);
    this.filter = null;
    this.tabNode = '';
    this.selectedCount = 0;
  }


  locationSearchFn(term: string, item: any) {
    term = term?.toLocaleLowerCase?.() || '';
    return (
      (item.associateName?.toLocaleLowerCase?.() || '').includes(term) ||
      item.locationId?.toString()?.includes(term) ||
      (item.address1?.toLocaleLowerCase?.() || '').includes(term) ||
      (item.address2?.toLocaleLowerCase?.() || '').includes(term) ||
      (item.associateAccountNumber?.toString()?.toLocaleLowerCase?.() || '').includes(term) ||
      (item.city?.toLocaleLowerCase?.() || '').includes(term) ||
      (item.state?.toLocaleLowerCase?.() || '').includes(term) ||
      (item.associatePhoneNumber?.toLocaleLowerCase?.() || '').includes(term) ||
      (item.zipCode?.toLocaleLowerCase?.() || '').includes(term)
    );
  }


  filterSearchFnForCropType(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return (item.cropTypeDesc.toLocaleLowerCase().indexOf(term) > -1 ||
      item.cropTypeCode.toLocaleLowerCase().indexOf(term) > -1);
  }

  filterSearchFnForVariety(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return (item.variety.toLocaleLowerCase().indexOf(term) > -1 ||
      item.variety.toLocaleLowerCase().indexOf(term) > -1);
  }

  keyPressNumbers(event) {
    const numbers = /^[-+]?[0-9]+$/;
    if (!numbers.test(event.key)) {
      return false;
    }
  }

  addInventoryRow() {
    let rowId = this.currentRowId + 1;
    this.InventoryDataSource.data.unshift({
      selected: false,
      isNewLine: true,
      cropTypeCode: null,
      cropTypeDesc: null,
      brand: null,
      marketingBrand: null,
      hasError: false,
      errorMessage: null,
      quantity: 0,
      committedQty: 0,
      availableQty: 0,
      uom: null,
      rowId: rowId,
      previousQty: 0,
      varietyFilteredList: this.varietyMasterList,
      lineErrors: {
        'rowId': rowId, 'errors': []
      }
    });
    this.currentRowId++;
    this.InventoryDataSource.data = [...this.InventoryDataSource.data];
    this.enableDisableUpdateButton();
  }

  onCropTypeOrVarietyChange(element, type) {
    if (type === "cropType") {
      element.brand = null;
      element.uom = null;
      element.marketingBrand = null;
      element.cropTypeDesc = null;
      element.committedQty = 0;
      element.availableQty = 0;
      element.quantity = 0;
      element.varietyFilteredList = this.varietyMasterList.filter(x => x.cropTypeCode == element.cropTypeCode);
      this.validateLineItem(element, 'cropType');
    } else {
      const selected = element.varietyFilteredList.find(x => x.variety === element.brand);
      if (selected) {
        element.marketingBrand = selected.marketingBrand;
      }
      const cropData = this.cropTypeMasterList.find(x => x.cropTypeCode === element.cropTypeCode);
      if (cropData) {
        element.uom = cropData.uom;
        element.cropTypeDesc = cropData.cropTypeDesc;
      }
      if (!element.brand) {
        element.uom = null;
        element.marketingBrand = null;
        element.cropTypeDesc = null;
        element.committedQty = 0;
        element.availableQty = 0;
        element.quantity = 0;
      }
      this.validateLineItem(element, 'brand');
    }


    this.InventoryDataSource.data = [...this.InventoryDataSource.data];
  }

  enableDisableUpdateButton() {
    const data = this.InventoryDataSource.data;

    const hasError = data.some(x => x.lineErrors?.errors?.length > 0);

    const hasChanges = data.some(x =>
      (!x.isNewLine && ((x.previousQty !== x.quantity) || (x.quantity === 0))) ||
      (x.isNewLine && +x.quantity > 0 && x.cropTypeCode && x.brand)
    );
    const hasDelete = this.deleteList.length > 0;

    this.isPlaceOrderDisable = hasError || (!hasChanges && !hasDelete);
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { plDataChange: true, labelNo: 'No, go back to Inventory Management' });
  }


  deleteSelectedItems(value) {
    if (value) {
      const source = this.InventoryDataSource.data;
      const remaining: any[] = [];
      const separateList: any[] = [];

      for (const item of source) {
        if (item.isNewLine && item.selected) {
          continue;
        }

        if ((!item.isNewLine && item.selected && item.committedQty <= 0)) {
          separateList.push({ ...item });
          continue;
        }

        this.validateDeleteError(item);
        remaining.push({ ...item });
      }
      this.InventoryDataSource.data = remaining.map(row => ({ ...row }));
      this.selectedCount = this.InventoryDataSource.data.filter(x => x.selected == true).length;
      this.deleteList.push(...separateList);
    }
    this.enableDisableUpdateButton();
    this.tabNode = '';
  }

  showAddNewItemInput() {
    this.isAddingNewItem = true;
    this.setTableHeight();
  }

  quantityTextChange(productItem) {
    if (/^0/.test(productItem.quantity) && productItem.quantity != '0') {
      productItem.quantity = productItem.quantity.replace(/^0/, '');
    }
    productItem.availableQty = +productItem.quantity - +productItem.committedQty;
    productItem.availableQty = Math.max(productItem.availableQty, 0);
    this.validateLineItem(productItem, null);
  }

  geuValueChange(value: string, element: any) {
    if (value == 'decrease') {
      const decValue = +element.quantity - 1;
      if (decValue > 0) {
        element.quantity = decValue;
      }
      else {
        element.quantity = 0;
      }
    }
    else {
      if (element.quantity <= 999998) {
        element.quantity = +element.quantity + 1;
      }

    }
    element.availableQty = +element.quantity - +element.committedQty;
    element.availableQty = Math.max(element.availableQty,0);
    this.validateLineItem(element,null);
  }

  validateLineItem(item: any,mode:string) {
    if (item.isNewLine && !item.cropTypeCode && (mode === 'cropType' || item.quantity > 0) ) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'cropType');
      item.lineErrors.errors.push({
        id: 'cropType', error: 'Please select Crop Type.'
      });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'cropType');
    }

    if (item.isNewLine && !item.brand && (mode === 'brand' || item.quantity > 0)) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'brand');
      item.lineErrors.errors.push({
        id: 'brand', error: 'Please select Variety.'
      });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'brand');
    }

    if (item.isNewLine) {
      if (this.InventoryDataSource.data.some(x => item.brand && x.brand == item.brand && x.rowId != item.rowId)) {
        item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'duplicateBrand');
        item.lineErrors.errors.push({
          id: 'duplicateBrand', error: 'Variety already exists.'
        });
      }
      else {
        item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'duplicateBrand');
      }
    }

    if (item.quantity < item.committedQty) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'committedQty');
      item.lineErrors.errors.push({
        id: 'committedQty', error: `Quantity cannot be less than committed quantity ${item.committedQty}.`
      });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'committedQty');
    }

    this.InventoryDataSource.data = [...this.InventoryDataSource.data];
    this.enableDisableUpdateButton();
    return item;
  }

  validateDeleteError(item: any) {
    if (!item.isNewLine && item.selected && item.committedQty > 0) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'deleteInventory');
      item.lineErrors.errors.push({
        id: 'deleteInventory', error: 'Cannot remove variety with committed quantity.'
      });
    } else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'deleteInventory');
    }
    return item;
  }

  hasAnyError(): boolean {
    return this.InventoryDataSource?.data.some(item => item.hasError);
  }


  validateForm(): boolean {
    if (!this.formdata.locationId) {
      this.toastrService.error('Location selection is required.');
      return false;
    }
    return true;
  }

  isFormValid(): boolean {
    return this.selectedItems.every(item => {
      if (item.quantity === 0) {
        return true;
      }
      return !!item.productLineId && !!item.marketingBrandId;
    });
  }

  refreshPage() {
    if (this.hasChangeAdded) {
      const title = 'Leave without saving?';
      const message = '';
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '480px',
        data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No, go back to Inventory Management', dialogType: 'confirm' }
      });
      this.subscription.push(dialogRef.afterClosed().subscribe(result => {
        if (result == true) {
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cancelBtnClick: true });
          this.sliderModelService.close();
          this.getDetailInventoryData(this.formdata.locationId);
          this._filter.clearAllFilterWithoutEmit();
          this.setDefaultformData(this.formdata.locationId);
          this.filter = null;
          this.tabNode = '';
          this.selectedCount = 0;
        }
      }));
    }
    else {
      this.sliderModelService.close();
      if (this.formdata.locationId) {
        this.getDetailInventoryData(this.formdata.locationId);
      }
      this._filter.clearAllFilterWithoutEmit();
      this.setDefaultformData(this.formdata.locationId);
      this.filter = null;
      this.tabNode = '';
      this.selectedCount = 0;
    }
  }


  saveOrder() {
    if (!this.validateForm() || !this.validateOrderItems()) {
      return;
    }
    this.getConfirmation();
  }

  validateOrderItems() {
    let isValidated = true;
    if (this.InventoryDataSource.data && this.InventoryDataSource.data.length > 0) {
      isValidated = true;
      this.InventoryDataSource.data.forEach(x => {
        x = this.validateLineItem(x,null);
        if (x.lineErrors.errors.length > 0) {
          isValidated = false;
        }
      });
    } else {
      isValidated = this.deleteList.length > 0;
    }
    return isValidated;
  }

  getConfirmation() {
    const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '480px',
      data: { message: "", title: 'Do you want to save the Inventory changes?', labelYes: 'Yes', labelNo: 'No', dialogType: 'confirm' }
    });

    this.subscription.push(dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.addUpdateInventory();
      }
    }));

  }

  addUpdateInventory() {
    this.loaderService.setLoaderStatus(true);
    this.deleteList.map(x => { x.quantity = 0 });
    const dataList = this.InventoryDataSource.data.filter(x => (!x.isNewLine && ((x.previousQty !== x.quantity) || (x.quantity === 0))) || (x.isNewLine === true && x.quantity > 0 && x.cropTypeCode && x.brand));
    const inventoryItems = [
      ...dataList,
      ...this.deleteList
    ].map(x => ({
      rowId: x.rowId,
      locationId: this.formdata?.locationId,
      inventoryId: x.inventoryId,
      cropTypeCode: x.cropTypeCode,
      brand: x.brand,
      quantity: x.quantity,
      uom: x.uom,
    }));

    if (inventoryItems?.length > 0) {
      this.subscription.push(this.associateCropService.AddUpdateInvetoryOrder(inventoryItems).subscribe((result: any) => {
        if (result && result.length > 0 && result.every(x => x.errors.length == 0)) {
          this.getDetailInventoryData(this.formdata?.locationId);
          this.tabNode = '';
          this.selectedCount = 0;
          this.showTabs = false;
          this.toastrService.success('Inventory updated successfully.');
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, {
            updateButtonClick: true
          });
        } else {
          const deleteList =
            result?.filter(r =>
              r.errors?.some(e => e.id === 'deleteInventory' || e.id === 'duplicateBrand')
            ) ?? [];

          const deleteRowIds = deleteList.map(x => x.rowId);
          const filteredSecondList = this.deleteList.filter(x =>
            deleteRowIds.includes(x.rowId)
          );
          
          this.deleteList = this.deleteList.filter(
            item => !deleteRowIds.includes(item.rowId)
          );
          this.InventoryDataSource.data.push(...filteredSecondList);
          this.InventoryDataSource.data.forEach(data => {
            data.lineErrors.errors = [];
            const matchedItem = result.find(
              x => x.rowId === data.rowId && x.errors?.length > 0
            );

          if (matchedItem) {
            data.availableQty = matchedItem.availableQty;
            data.committedQty = matchedItem.committedQty;
            data.quantity = matchedItem.quantity;

            matchedItem.errors.forEach(err => {
              if (!data.isNewLine && err.id === 'deleteInventory') {
                data.selected = true;
              }
              if (!data.isNewLine && err.id === 'duplicateBrand') {
                //data.selected = false;
                return;
              }
              data.lineErrors.errors.push({
                id: err.id,
                error: err.error
              });
            });

            }
          });

          this.InventoryDataSource.data = [...this.InventoryDataSource.data];
          this.selectedCount = this.InventoryDataSource.data.filter(x => x.selected == true).length;
          if (this.selectedCount) {
            this.showTabs = false;
            this.tabNode = '';
          }
          this.enableDisableUpdateButton();
          this.loaderService.setLoaderStatus(false);

        }

      }, error => {
        this.loaderService.setLoaderStatus(false);
      }));
    }
  }



  ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  isExpansionRow = (_: number, row: any) => {
    return row?.lineErrors?.errors?.length > 0;
  };

  inventoryFilterPredicate = (data: any, filter: any): boolean => {
    if (data.isNewLine === true) {
      return true;
    }
    return (
      (!filter?.brandList ||
        filter.brandList
          .trim()
          .toLowerCase()
          .split(',')
          .some(x =>
            data.brand?.trim().toLowerCase().includes(x.trim())
          )
      )
      &&
      (!filter?.cropTypeCode ||
        filter.cropTypeCode.includes(data.cropTypeCode)
      )
      &&
      (!filter?.marketingBrand ||
        filter.marketingBrand.includes(data.marketingBrand)
      )
    );
  };

  public exportData() {
    const exportData = [];
    const currentFilter = this.InventoryDataSource.filter;

    const dataForExport = this.inventoryOriginalDataSourceGrid.filter(row =>
      this.inventoryFilterPredicate(row, currentFilter)
    );

    if (dataForExport && dataForExport.length > 0) {
      this.loaderService.setLoaderStatus(true);
      dataForExport.forEach(x => {
        exportData.push({
          'Crop Type': x.cropTypeDesc,
          'Variety': x.brand,
          'Marketing Brand': x.marketingBrand,
          'Quantity': +x.quantity,
          'Committed Qty': +x.committedQty,
          'Available Qty': +x.availableQty,
          'UOM': x.uom,
        });
      });
      this.excelService.exportAsExcelFileWithDateWithoutExport(exportData, 'Associate_crop_Inventory_');
      this.loaderService.setLoaderStatus(false);
    }
  }


}
export class AssociateOrderInventoryFilterVM {
  cropTypeCode: string;
  marketingBrand: string;
  brandList: string;
}
